// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"453":"92c8ef06","667":"8bef0b86"}[chunkId] + ".chunk.js");